export const getLocalStorage = (key: string) => localStorage.getItem(key) || '';

export const setLocalStorage = (key: string, values: string) => localStorage.setItem(key, values);

export const removeLocalStorage = (key: string) => localStorage.removeItem(key);
